import { render, staticRenderFns } from "./SelectableListBase.vue?vue&type=template&id=1f8b87e9&scoped=true"
import script from "./SelectableListBase.vue?vue&type=script&lang=js"
export * from "./SelectableListBase.vue?vue&type=script&lang=js"
import style0 from "./SelectableListBase.vue?vue&type=style&index=0&id=1f8b87e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8b87e9",
  null
  
)

export default component.exports